  <div id="pdf_renderer">
    <div>
      <img
        [src]="preview_url"
        style="display: none"
        alt="preview-image"
      />
    </div>
  
    <div class="pdf-container">
      <div class="text-center" *ngIf="is_loading == true">
        <img src="assets/themes/images/primary-loader.gif" width="40" height="40"  alt="loader-image" />
      </div>
      <pdf-viewer [src]="pdfscr"
      [render-text]="true"
      (after-load-complete)="callBackFn()"
      [original-size]="false"
      [fit-to-page]="true"
      (error)="onPdfError($event)"
      style="width: 100%; height: 100vh;"
      ></pdf-viewer>

    
    </div>
  </div>